import { render } from "./Author.vue?vue&type=template&id=1cbda31a&scoped=true"
import script from "./Author.vue?vue&type=script&lang=js"
export * from "./Author.vue?vue&type=script&lang=js"

import "./Author.vue?vue&type=style&index=0&id=1cbda31a&lang=css"
import "./Author.vue?vue&type=style&index=1&id=1cbda31a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1cbda31a"]])

export default __exports__